import server from "../server";

export type SaveToken = {
    token: string;
    exp: number; // stored in ms
};


const REFRESH_STORAGE_KEY = process.env.REACT_APP_REFRESH_TOKEN_KEY!;

export const setToken = (saveToken: SaveToken) => {
    localStorage.setItem(REFRESH_STORAGE_KEY, JSON.stringify(saveToken));
};

export const getRefreshToken = (): SaveToken | null => {
    try {
        const data = localStorage.getItem(REFRESH_STORAGE_KEY);
        if (!data) return null;

        const parsed = JSON.parse(data);

        if (!parsed?.token || typeof parsed.token !== "string") {
            return null;
        }

        return parsed;
    } catch {
        return null;
    }
};

export const clearAuth = () => {
    localStorage.removeItem(REFRESH_STORAGE_KEY);
    localStorage.removeItem("id");
};



export const triggerRefresh = async () => {
    const refreshToken = getRefreshToken();

    // Missing or locally expired refresh token
    if (
        !refreshToken?.token ||
        !refreshToken.exp ||
        refreshToken.exp <= Date.now()
    ) {
        logout();
        throw new Error("No valid token found");
    }

    try {
        await server.auth.refreshToken(refreshToken.token);
    } catch (err: any) {
        const status = err?.response?.status;

        // Invalid or expired refresh token
        if ([400, 401, 403].includes(status)) {
            logout();
        }

        // Preserve the error for ApiInterceptor
        throw err;
    }
};



export const initTokenRefresh = () => {
    const tokenData = getRefreshToken();

    if (!tokenData) {
        clearAuth();
        return;
    }

    const now = Date.now();

    if (!tokenData.exp || tokenData.exp <= now) {
        clearAuth();
    }
};


export const logout = () => {
    clearAuth();
    window.dispatchEvent(new Event("logout"));
};
